import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You can sync data from Meta Ads reports by configuring it as a source in PostHog. The supported reports that can be synced include Adsets, Campaigns, Ads, Adset Report, Campaign Report, and Ad Report, as described here:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developers.facebook.com/docs/marketing-api/reference/ad-account/adsets/"
        }}>{`Adsets`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developers.facebook.com/docs/marketing-api/reference/ad-account/campaigns/"
        }}>{`Campaigns`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developers.facebook.com/docs/marketing-api/reference/ad-account/ads/"
        }}>{`Ads`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developers.facebook.com/docs/marketing-api/reference/ad-account/insights/"
        }}>{`Adset Insight`}</a>{`: filtered by level = `}<inlineCode parentName="li">{`adset`}</inlineCode></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developers.facebook.com/docs/marketing-api/reference/ad-account/insights/"
        }}>{`Campaign Insight`}</a>{`: filtered by level = `}<inlineCode parentName="li">{`campaign`}</inlineCode></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developers.facebook.com/docs/marketing-api/reference/ad-account/insights/"
        }}>{`Ad Insight`}</a>{`: filtered by level = `}<inlineCode parentName="li">{`ad`}</inlineCode></li>
    </ul>
    <p>{`Additional reports will be added based on user feedback we receive via our `}<a parentName="p" {...{
        "href": "https://app.posthog.com/#panel=support%3Afeedback%3Adata_warehouse%3Alow%3Atrue"
      }}>{`in-app support form`}</a>{`.`}</p>
    <h2 {...{
      "id": "requirements"
    }}>{`Requirements`}</h2>
    <ul>
      <li parentName="ul">{`A Meta Ads account with permission to access data from accounts you want to sync.`}</li>
      <li parentName="ul">{`Your account ID from the `}<a parentName="li" {...{
          "href": "https://adsmanager.facebook.com/"
        }}>{`ads manager`}</a>{` > Menu > Campaigns > Right next to the title you will see a dropdown > get the ID from the account or check the url `}<inlineCode parentName="li">{`https://adsmanager.facebook.com/adsmanager/manage/campaigns?act=ID_HERE`}</inlineCode></li>
    </ul>
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/w_500,c_limit,q_auto,f_auto/Screenshot_2025_09_30_at_2_14_45_PM_ecce1881cf.png" classes="rounded" alt="Meta account ID" mdxType="ProductScreenshot" />
    <h2 {...{
      "id": "configuring-posthog"
    }}>{`Configuring PostHog`}</h2>
    <p>{`Connect PostHog to your Meta Ads account using a Meta account. The Meta account must have permission to access data.`}</p>
    <ol>
      <li parentName="ol">{`In PostHog, go to the `}<strong parentName="li"><a parentName="strong" {...{
            "href": "https://app.posthog.com/pipeline/sources"
          }}>{`Data pipelines`}</a></strong>{` tab.`}</li>
      <li parentName="ol">{`Open the `}<strong parentName="li">{`+ New`}</strong>{` drop-down menu in the top-right and select `}<strong parentName="li">{`Source`}</strong>{`.`}</li>
      <li parentName="ol">{`Find Meta Ads in the sources list and click `}<strong parentName="li">{`Link`}</strong>{`.`}</li>
      <li parentName="ol">{`Enter the `}<strong parentName="li">{`Account ID`}</strong>{` of the Meta Ads account you want to sync.`}</li>
      <li parentName="ol">{`Select an existing Meta Ads account, or create a new integration.`}</li>
      <li parentName="ol">{`(Optional) Add a prefix for the table name.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      